import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(80)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(80)} 0 ${rem(80)} 0;
    }
`;

export const CarouselWrapper = styled.div`
    padding: ${rem(20)};
`;

export const Client = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${rem(20)};
    padding-bottom: ${rem(40)};
`;

export const ClientImage = styled.img`
    width: 70%;
    margin: 0 auto;
`;
